import React from "react";

const C = {
  navy: "#1B3A5C",
  teal: "#2A9D8F",
  gold: "#E8A020",
};

/** Icône seule — fond navy arrondi, 3 barres teal ascendantes + point doré */
export function PsyGestionIcon({ size = 36 }: { size?: number }) {
  const rx = Math.round((14 / 64) * size);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="PsyGestion"
    >
      <rect width="64" height="64" rx={rx} fill={C.navy} />
      {/* Barre gauche — courte */}
      <rect x="10" y="36" width="12" height="16" rx="4" fill={C.teal} />
      {/* Barre centre — moyenne */}
      <rect x="26" y="24" width="12" height="28" rx="4" fill={C.teal} />
      {/* Barre droite — haute */}
      <rect x="42" y="14" width="12" height="38" rx="4" fill={C.teal} />
      {/* Point doré — signal "premium" */}
      <circle cx="48" cy="10" r="4" fill={C.gold} />
    </svg>
  );
}

/** Logo complet — icône + texte "PsyGestion" */
export function PsyGestionLogoFull({ height = 48 }: { height?: number }) {
  return (
    <svg
      viewBox="0 0 252 64"
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="PsyGestion"
      style={{ overflow: "visible" }}
    >
      {/* Icône */}
      <rect width="64" height="64" rx="14" fill={C.navy} />
      <rect x="10" y="36" width="12" height="16" rx="4" fill={C.teal} />
      <rect x="26" y="24" width="12" height="28" rx="4" fill={C.teal} />
      <rect x="42" y="14" width="12" height="38" rx="4" fill={C.teal} />
      <circle cx="48" cy="10" r="4" fill={C.gold} />

      {/* Texte */}
      <text
        x="80"
        y="42"
        fontFamily="'Inter', 'Outfit', system-ui, -apple-system, sans-serif"
        fontSize="28"
        fontWeight="800"
        letterSpacing="-0.5"
        fill={C.navy}
      >
        Psy
      </text>
      <text
        x="131"
        y="42"
        fontFamily="'Inter', 'Outfit', system-ui, -apple-system, sans-serif"
        fontSize="28"
        fontWeight="600"
        letterSpacing="-0.3"
        fill={C.teal}
      >
        Gestion
      </text>
    </svg>
  );
}

/**
 * Spinner de chargement branded — remplace le 🧠 animate-spin.
 * Anneau teal qui tourne autour de l'icône.
 */
export function PsyGestionSpinner({ size = 56 }: { size?: number }) {
  const iconSize = Math.round(size * 0.6);
  return (
    <div style={{ position: "relative", width: size, height: size, display: "flex", alignItems: "center", justifyContent: "center" }}>
      {/* Anneau animé */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 56 56"
        style={{ position: "absolute", top: 0, left: 0, animation: "psySpinner 1s linear infinite" }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>{`@keyframes psySpinner { to { transform: rotate(360deg); } }`}</style>
        <circle cx="28" cy="28" r="24" fill="none" stroke="#D6E4F0" strokeWidth="3" />
        <path
          d="M28 4 A24 24 0 0 1 52 28"
          fill="none"
          stroke={C.teal}
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      {/* Icône centrale */}
      <PsyGestionIcon size={iconSize} />
    </div>
  );
}
